module.exports = __webpack_public_path__ + "img/shop-2.35917416.jpg";